import React, { useMemo } from 'react';

const CodeValidationGate = ({
  language,
  handleCodeFormSubmit,
  codeClient,
  setCodeClient,
  codeValidationError,
  setCodeValidationError,
  isCheckingCode
}) => {
  const t = useMemo(() => ({
    codeTitle: language === 'fr' ? 'Validation du code client' : 'Client code validation',
    codeDescription: language === 'fr'
      ? 'Veuillez valider votre code client pour acceder au formulaire du camp de jour.'
      : 'Please validate your client code to access the day camp form.',
    codeLabel: language === 'fr' ? 'Code client' : 'Client code',
    codePlaceholder: language === 'fr' ? 'Entrez votre code client' : 'Enter your client code',
    codeButton: language === 'fr' ? 'Valider le code' : 'Validate code',
    codeButtonLoading: language === 'fr' ? 'Validation en cours...' : 'Validating...'
  }), [language]);

  return (
    <form className="formulaire-dynamique-main-div code-validation-card" onSubmit={handleCodeFormSubmit}>
      <div className="code-validation-header">
        <h2 className="code-validation-title">{t.codeTitle}</h2>
        <span className="formulaire-dynamique-span code-validation-description">{t.codeDescription}</span>
      </div>
      <div className="formulaire-dynamique-label-wrapper">
        <span className="formulaire-dynamique-span">{t.codeLabel} *</span>
      </div>
      <div className="input-container code-validation-input-container">
        <div className="code-validation-input-row">
          <input
            type="text"
            value={codeClient}
            onChange={(e) => {
              setCodeClient(e.target.value);
              if (codeValidationError) {
                setCodeValidationError('');
              }
            }}
            className="profile-input code-validation-input"
            placeholder={t.codePlaceholder}
            disabled={isCheckingCode}
          />
          <button
            type="submit"
            className="submit-button-formulaire-dynamique code-validation-button"
            disabled={isCheckingCode}
          >
            {isCheckingCode ? t.codeButtonLoading : t.codeButton}
          </button>
        </div>
        {codeValidationError && (
          <span className="color-error formulaire-dynamique-span">{codeValidationError}</span>
        )}
      </div>
      <div className="code-validation-button-mobile">
        <button
          type="submit"
          className="submit-button-formulaire-dynamique code-validation-button"
          disabled={isCheckingCode}
        >
          {isCheckingCode ? t.codeButtonLoading : t.codeButton}
        </button>
      </div>
    </form>
  );
};

export default CodeValidationGate;
